<div class="reset-password-split-container">
  <div class="reset-password-illustration">
    <div class="illustration-content">
      <h2 class="illustration-title">Secure Password Reset</h2>
      <img
        ngSrc="/assets/img/data-management.png"
        alt="hero-image"
        class="illustration-img"
        width="400"
        height="300"
      />
    </div>
  </div>
  <div class="reset-password-form-container">
    <div class="reset-password-form-box">
      <!-- App Logo -->
      <div class="app-logo">
        <img
          ngSrc="/assets/img/logo.png"
          alt="AZAADI 2.0 Logo"
          class="logo-img"
          width="120"
          height="40"
          onerror="this.style.display='none'"
        />
      </div>
      <h1 class="reset-password-title">AZAADI 2.0</h1>

      <!-- Invalid Token State -->
      <div *ngIf="!tokenValid" class="error-content">
        <div class="error-icon">⚠️</div>
        <h3 class="error-title">Invalid Reset Link</h3>
        <p class="error-message">
          This password reset link is invalid or has expired. Please request a
          new password reset.
        </p>
        <div class="error-actions">
          <button type="button" class="primary-btn" (click)="requestNewReset()">
            Request New Reset
          </button>
          <button type="button" class="secondary-btn" (click)="goToLogin()">
            Back to Login
          </button>
        </div>
      </div>

      <!-- Reset Form State -->
      <div *ngIf="tokenValid && !passwordReset" class="form-content">
        <p class="reset-password-welcome">
          Create a new secure password for your account.
        </p>
        <form
          [formGroup]="resetPasswordForm"
          (ngSubmit)="onSubmit()"
          novalidate
        >
          <!-- New Password Field -->
          <div class="form-group">
            <label for="newPassword">New Password</label>
            <div class="password-input-container">
              <input
                [type]="showPassword ? 'text' : 'password'"
                id="newPassword"
                formControlName="newPassword"
                required
                placeholder="Enter new password"
                autocomplete="new-password"
              />
              <button
                type="button"
                class="password-toggle"
                (click)="togglePasswordVisibility()"
                tabindex="-1"
              >
                <img
                  *ngIf="showPassword"
                  ngSrc="/assets/img/show.png"
                  alt="Show password"
                  aria-label="Show password"
                  title="Show password"
                  width="20"
                  height="20"
                />
                <img
                  *ngIf="!showPassword"
                  ngSrc="/assets/img/hidden.png"
                  alt="Hide password"
                  aria-label="Hide password"
                  title="Hide password"
                  width="20"
                  height="20"
                />
              </button>
            </div>

            <!-- Password Strength Indicator -->
            <!-- <div class="password-strength" *ngIf="resetPasswordForm.get('newPassword')?.value">
              <div class="strength-bar">
                <div class="strength-fill" [class]="getPasswordStrengthClass()"></div>
              </div>
              <span class="strength-text" [class]="getPasswordStrengthClass()">
                {{ getPasswordStrengthText() }}
              </span>
            </div> -->

            <!-- Password Validation Errors -->
            <div
              class="error"
              *ngIf="
                resetPasswordForm.get('newPassword')?.touched &&
                resetPasswordForm.get('newPassword')?.invalid
              "
            >
              <span
                *ngIf="
                  resetPasswordForm.get('newPassword')?.errors?.['required']
                "
              >
                Password is required.
              </span>
              <span
                *ngIf="
                  resetPasswordForm.get('newPassword')?.errors?.['minlength']
                "
              >
                Password must be at least 8 characters long.
              </span>
              <span
                *ngIf="
                  resetPasswordForm.get('newPassword')?.errors?.[
                    'passwordStrength'
                  ]
                "
              >
                Password must contain uppercase, lowercase, number, and special
                character.
              </span>
            </div>
          </div>

          <!-- Confirm Password Field -->
          <div class="form-group">
            <label for="confirmPassword">Confirm Password</label>
            <div class="password-input-container">
              <input
                [type]="showConfirmPassword ? 'text' : 'password'"
                id="confirmPassword"
                formControlName="confirmPassword"
                required
                placeholder="Confirm new password"
                autocomplete="new-password"
              />
              <button
                type="button"
                class="password-toggle"
                (click)="toggleConfirmPasswordVisibility()"
                tabindex="-1"
              >
                <img
                  *ngIf="showConfirmPassword"
                  ngSrc="/assets/img/show.png"
                  alt="Show password"
                  aria-label="Show password"
                  title="Show password"
                  width="20"
                  height="20"
                />
                <img
                  *ngIf="!showConfirmPassword"
                  ngSrc="/assets/img/hidden.png"
                  alt="Hide password"
                  aria-label="Hide password"
                  title="Hide password"
                  width="20"
                  height="20"
                />
              </button>
            </div>

            <!-- Confirm Password Validation Errors -->
            <div
              class="error"
              *ngIf="
                resetPasswordForm.get('confirmPassword')?.touched &&
                resetPasswordForm.get('confirmPassword')?.invalid
              "
            >
              <span
                *ngIf="
                  resetPasswordForm.get('confirmPassword')?.errors?.['required']
                "
              >
                Please confirm your password.
              </span>
            </div>

            <!-- Password Mismatch Error -->
            <div
              class="error"
              *ngIf="
                resetPasswordForm.errors?.['passwordMismatch'] &&
                resetPasswordForm.get('confirmPassword')?.touched
              "
            >
              Passwords do not match.
            </div>
          </div>

          <button
            type="submit"
            class="reset-password-btn"
            [disabled]="loading || resetPasswordForm.invalid"
          >
            <span *ngIf="loading" class="spinner"></span>
            <span *ngIf="!loading">Reset Password</span>
          </button>
        </form>

        <div class="form-actions">
          <button type="button" class="back-to-login-btn" (click)="goToLogin()">
            ← Back to Login
          </button>
        </div>
      </div>

      <!-- Success State -->
      <div *ngIf="passwordReset" class="success-content">
        <div class="success-icon">✅</div>
        <h3 class="success-title">Password Reset Successfully!</h3>
        <p class="success-message">
          Your password has been reset successfully. You can now login with your
          new password.
        </p>
        <div class="success-actions">
          <button type="button" class="primary-btn" (click)="goToLogin()">
            Go to Login
          </button>
        </div>
      </div>

      <footer class="reset-password-footer">
        ©{{ currentYear }} AZAADI. All rights reserved.
      </footer>
    </div>
  </div>
</div>
